// extracted by mini-css-extract-plugin
module.exports = {"Albums":"Albums_Albums__3S6cj","ArtistImageWrapper":"Albums_ArtistImageWrapper__3auYi","ArtistImage":"Albums_ArtistImage__woXAy","ArtistDetails":"Albums_ArtistDetails__3Ue0S"};